import { ConfigService } from './config.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog'
import { Observable } from 'rxjs';
import { CotizacionCabecera } from '../models/cotizacionCabecera';
import { TokenService } from '../utils/token.service';
import { environment } from 'src/environments/environment';
import { DataClientePedidos } from '../models/dataClientePedidos';

@Injectable({
  providedIn: 'root'
})

export class AdmService {

  private admServerUri: string;
  private apiUrl = environment.apiUrl;

  constructor(private configService: ConfigService, private dialog: MatDialog, private httpCliente: HttpClient, private tokenService: TokenService) {
    this.admServerUri = /*this.configService.ServerURI*/this.apiUrl + '/' + this.configService.AdmURI;
  }

  private getHeaders() {
    const authToken = this.tokenService.getAuthToken();
    const authTokenBearer = this.tokenService.getAuthTokenBearer();

    return new HttpHeaders({
      'Authorization': `Bearer ${authTokenBearer}`,
      'PortalO2G': `${authToken}`
    });
  }

  cZonasVendedoresAutocompleteSearch(idPais: string, idCompania: string, idSalesOrg: string, search: string) {
    return this.httpCliente.get(this.admServerUri + 'CZonasVendedoresAutocompleteSearch?idPais=' + idPais + "&idCompania=" + idCompania + "&idSalesOrg=" + idSalesOrg + "&search=" + search, { headers: this.getHeaders() });
  }

  cDireccionesDistribuidorCliente(idPais: string, idCompania: string, idSalesOrg: string, nroCliente: string) {
    return this.httpCliente.get(this.admServerUri + 'CDireccionesDistribuidorCliente?idPais=' + idPais + "&idCompania=" + idCompania + "&idSalesOrg=" + idSalesOrg + "&nroCliente=" + nroCliente, { headers: this.getHeaders() });
  }
  cSucursales(nroCliente: string) {
    return this.httpCliente.get(this.admServerUri + 'CSucursales?nroCliente=' + nroCliente, { headers: this.getHeaders() });
  }
  cDataClienteSeleccionado(idPais: string, idCompania: string, idSalesOrg: string, idDivision: string, nroCliente: string) {
    return this.httpCliente.get(this.admServerUri + 'CDataClienteSeleccionado?idPais=' + idPais + "&idCompania=" + idCompania + "&idSalesOrg=" + idSalesOrg + "&idDivision=" + idDivision + "&nroCliente=" + nroCliente, { headers: this.getHeaders() });
  }
  cDataCliente(idPais: string, idCompania: string, idSalesOrg: string, nroCliente: string) {
    return this.httpCliente.get(this.admServerUri + 'CDataCliente?idPais=' + idPais + "&idCompania=" + idCompania + "&idSalesOrg=" + idSalesOrg + "&nroCliente=" + nroCliente, { headers: this.getHeaders() });
  }
  cMensajesCliente(idPais: string, idCompania: string, idSalesOrg: string, nroCliente: string) {
    return this.httpCliente.get(this.admServerUri + 'cMensajesCliente?idPais=' + idPais + "&idCompania=" + idCompania + "&idSalesOrg=" + idSalesOrg + "&nroCliente=" + nroCliente, { headers: this.getHeaders() });
  }
  cDataClienteSeleccionadoAwait(idPais: string, idCompania: string, idSalesOrg: string, idDivision: string, nroCliente: string): Promise<DataClientePedidos> {
    return this.httpCliente.get<DataClientePedidos>(this.admServerUri + 'CDataClienteSeleccionado?idPais=' + idPais + "&idCompania=" + idCompania + "&idSalesOrg=" + idSalesOrg + "&idDivision=" + idDivision + "&nroCliente=" + nroCliente, { headers: this.getHeaders() }).toPromise();
  }

  cDireccionesEntregaAutocompleteSearch(idPais: string, idCompania: string, idSalesOrg: string, nroCliente: string, search: string) {
    nroCliente = nroCliente == null ? "" : nroCliente;
    return this.httpCliente.get(this.admServerUri + 'CDireccionesEntregaAutocompleteSearch?idPais=' + idPais + "&idCompania=" + idCompania + "&idSalesOrg=" + idSalesOrg + "&nroCliente=" + nroCliente + "&search=" + search, { headers: this.getHeaders() });
  }

  cClientesPedidoAutocompleteSearch(idPais: string, idCompania: string, idSalesOrg: string, idDivision: string, idZonaVendedor: string, idRegion: string, search: string,) {
    return this.httpCliente.get(this.admServerUri + 'CClientesPedidoAutocompleteSearch?idPais=' + idPais + "&idCompania=" + idCompania + "&idSalesOrg=" + idSalesOrg + "&idDivision=" + idDivision + "&idZonaVendedor=" + idZonaVendedor + "&idRegion=" + idRegion + "&search=" + search, { headers: this.getHeaders() });
  }

  cPaises() {
    return this.httpCliente.get(this.admServerUri + 'CPaises', { headers: this.getHeaders() });
  }

  cCompanias(idPais: string) {
    return this.httpCliente.get(this.admServerUri + 'CCompanias?idPais=' + idPais, { headers: this.getHeaders() });
  }

  cTiposNC(idPais: string, combo: boolean) {
    return this.httpCliente.get(this.admServerUri + 'CTiposNC?idPais=' + idPais + "&combo=" + combo, { headers: this.getHeaders() });
  }

  cSalesOrgs(idPais: string, idCompania: string) {
    return this.httpCliente.get(this.admServerUri + 'CSalesOrgs?idPais=' + idPais + "&idCompania=" + idCompania, { headers: this.getHeaders() });
  }

  cEstadosPedidos(idPais: string, idTipoComprobante: string) {
    return this.httpCliente.get(this.admServerUri + 'CEstadosPedidos?idPais=' + idPais + "&idTipoComprobante=" + idTipoComprobante, { headers: this.getHeaders() });
  }
  cEstados(idPais: string) {
    return this.httpCliente.get(this.admServerUri + 'CEstados?idPais=' + idPais, { headers: this.getHeaders() });
  }

  cDivisiones(idPais: string, idCompania: string, idSalesOrg: string, userName: string) {
    if (idCompania == null || idSalesOrg == null) {
      return this.httpCliente.get(this.admServerUri + 'CDivisionesCombo?idPais=' + idPais + '&userName=' + userName, { headers: this.getHeaders() });
    } else {
      return this.httpCliente.get(this.admServerUri + 'CDivisiones?idPais=' + idPais + "&idCompania=" + idCompania + "&idSalesOrg=" + idSalesOrg + "&userName=" + userName, { headers: this.getHeaders() });
    }
  }

  cRegiones(idPais: string, idCompania: string, idSalesOrg: string) {
    if (idCompania == null || idSalesOrg == null) {
      return this.httpCliente.get(this.admServerUri + 'CRegionesCombo?idPais=' + idPais, { headers: this.getHeaders() });
    } else {
      return this.httpCliente.get(this.admServerUri + 'CRegiones?idPais=' + idPais + "&idCompania=" + idCompania + "&idSalesOrg=" + idSalesOrg, { headers: this.getHeaders() });
    }
  }

  cZonasVendedores(idPais: string, idCompania: string, idSalesOrg: string, idDivision: string) {
    return this.httpCliente.get(this.admServerUri + 'CZonasVendedores?idPais=' + idPais + "&idCompania=" + idCompania + "&idSalesOrg=" + idSalesOrg + "&idDivision=" + idDivision, { headers: this.getHeaders() });
  }

  cLogsAutorizaciones(idPais: string, idCompania: string, idSalesOrg: string, idDivision: string, idTipoOrden: string, nroPedido: number) {
    return this.httpCliente.get(this.admServerUri + 'CLogsAutorizaciones?idPais=' + idPais + "&idCompania=" + idCompania + "&idSalesOrg=" + idSalesOrg + "&idDivision=" + idDivision + "&idTipoOrden=" + idTipoOrden + "&nroPedido=" + nroPedido, { headers: this.getHeaders() });
  }

  actualizarEmail(cab: CotizacionCabecera) {
    return this.httpCliente.post(this.admServerUri + 'ActualizarEmail', cab, { headers: this.getHeaders() });
  }
  actualizarEmailOpcional(cab: CotizacionCabecera) {
    return this.httpCliente.post(this.admServerUri + 'ActualizarEmailOpcional', cab, { headers: this.getHeaders() });
  }
  downloadPdf(nombrepdf: string) {
    return this.httpCliente.get(this.admServerUri + `ArchivoPDF?nombrepdf=${nombrepdf}`, {
      headers: this.getHeaders(),
      responseType: 'blob' // Important for binary data
    });
  }

  enviarMailaDistribuidor(nroPedido: number, idTipoOrden: string, nroDistribuidor: string) {
    return this.httpCliente.get(this.admServerUri + `EnviarMailaDistribuidor?nroPedido=${nroPedido}&idTipoOrden=${idTipoOrden}&nroDistribuidor=${nroDistribuidor}`, {
      headers: this.getHeaders(),
      responseType: 'text'
    });
  }
}
